import React from 'react';
import PropTypes from 'prop-types';

const SuppCardDetails = ({
  formSubmissionPayload,
  headers,
  dependsonId,
  cssProperties,
}) => (
  <>
    <div className="row">
      <div className="col-md-offset-1 col-md-4">
        <div className={cssProperties.headingStyle}>{headers.col1}</div>
      </div>
      <div className="col-md-4">
        <div className={cssProperties.headingStyle}>{headers.col2}</div>
      </div>
    </div>
    {
      formSubmissionPayload[dependsonId] && formSubmissionPayload[dependsonId].length > 0
      && formSubmissionPayload[dependsonId].map((i) => (
        <div className="row" key={i.accountToken}>
          <div className="col-md-offset-1 col-md-4">
            <div>{i.embossedName}様</div>

          </div>
          <div className="col-md-4">
            <div>{i.displayNumber}</div>
          </div>
        </div>
      ))
    }

  </>

);

SuppCardDetails.propTypes = {
  formSubmissionPayload: PropTypes.string,
  headers: PropTypes.string,
  cssProperties: PropTypes.string,
  dependsonId: PropTypes.string,
};

export default SuppCardDetails;
